import { usePlayerEvent } from './use-player-event';
export const useOnLoaded = (player, onChange) => {
  usePlayerEvent(player, 'loadeddata', () => player && onChange && onChange(player));
};